import React from "react";

import DataServiceJobButton from "../../components/use_case/data_service_job_button";

import { generateDataServiceJobPlaceholder } from "../../utility/placeholders";

const job = generateDataServiceJobPlaceholder();

export default () => <DataServiceJobButton isPlaceholder {...job} />;
